import { Getter } from 'vuex'
import { UserState } from '../types'
import { RootState } from '@/store/types'

const getUserEmail: Getter<UserState, RootState> = (state) => {
  return state.current?.email || ''
}

export default getUserEmail
